export const HEALTH_ISSUES = [
  {label: "Mucus", value: "mucus", color: "teal"},
  {label: "Paleness", value: "paleness", color: "cyan"},
  {label: "Bleaching", value: "bleaching", color: "orange"},
  {label: "Tissue loss", value: "tissue_loss", color: "yellow"},
  {label: "Dead", value: "dead_fragments", color: "gray"},
  {label: "Algae", value: "algae", color: "green"},
  {label: "Aptasia", value: "aptasia", color: "blue"},
  {label: "Parasites", value: "parasites", color: "purple"},
  {label: "Predation", value: "predation", color: "red"},
];

export const getIssueLabel = (value?: string) =>
  HEALTH_ISSUES.find((i) => i.value === value)?.label || "";

export const getIssueColor = (value?: string) =>
  HEALTH_ISSUES.find((i) => i.value === value)?.color || "";
